import {useState} from 'react'
// import docDefault from '../../../../media/images/Placeholder.png'
// import doc2 from '../../../../media/images/doc2.png'
import '../styles/resources.scss'

import {Swiper, SwiperSlide} from 'swiper/react'

// Import Swiper styles
import 'swiper/css'
import 'swiper/css/free-mode'
import 'swiper/css/navigation'
import 'swiper/css/thumbs'

// import required modules
import {FreeMode, Navigation, Thumbs} from 'swiper/modules'

interface ImageCarouselProps {
  images?: string[]
}

export default function ImageCarousel({images}: ImageCarouselProps) {
  const [thumbsSwiper,setThumbsSwiper] = useState(null)
  const handleSwiper = (swiper:any) => {
    setThumbsSwiper(swiper);
  };
  return (
    <>
      <Swiper
        loop={true}
        spaceBetween={10}
        navigation={true}
        thumbs={{swiper: thumbsSwiper}}
        modules={[FreeMode, Navigation, Thumbs]}
        className='mySwiper2'
      >
        {images?.map((image, index) => (
          <SwiperSlide key={index}>
            <img src={image} alt='Document banner' />
          </SwiperSlide>
        ))}
      </Swiper>

      <Swiper
        onSwiper={handleSwiper}
        loop={true}
        spaceBetween={6}
        slidesPerView={4}
        freeMode={true}
        watchSlidesProgress={true}
        modules={[FreeMode, Navigation, Thumbs]}
        className="mySwiper mt-4"
      >
        {/* Here you can map over images for thumbnails */}
        {images?.map((image, index) => (
          <SwiperSlide key={index}>
            <img src={image} alt={`Thumbnail ${index}`} />
          </SwiperSlide>
        ))}
      </Swiper>
    </>
  )
}
